import { VendorStockInRequestFormPage } from "@/features/vendor-app/pages/VendorStockInRequestFormPage";
import { createFileRoute } from "@tanstack/react-router";

export type VendorStockInRequestNewSearch = {
	/**
	 * Request this one is raised from — set when a rejected request is re-sent,
	 * so the form can prefill itself from it. In the URL so a reload keeps the
	 * prefill instead of dropping the vendor into an empty form.
	 */
	from?: string;
};

export const Route = createFileRoute("/vendor/stock-in-request/new")({
	validateSearch: (
		search: Record<string, unknown>,
	): VendorStockInRequestNewSearch => ({
		from:
			typeof search.from === "string" && search.from !== ""
				? search.from
				: undefined,
	}),
	component: VendorStockInRequestFormPage,
});
